import React from 'react';
import './PressSection.css';
import { Link } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import combinedPressLogos from '../../../assets/Prensa.png';

const PressSection: React.FC = () => {
  const { i18n, t } = useTranslation(); 
  const currentLang = i18n.language.split('-')[0];

  return (
    <section className="press-section">
      <div className="press-header-title">
        <h2 className="section-title">
          <Trans i18nKey="press:title" />
        </h2>
      </div>

      <div className="press-logos-container">
        <img
          src={combinedPressLogos}
          alt="Press logos"
          className="combined-press-image"
        />
      </div>

      <div className="press-footer-white-background">
        <Link to={`/${currentLang}/prensa`} className="see-more-link">
          <Trans i18nKey="press:cta" />
        </Link>

        <div className="linea-global press-bottom-spacer"></div>
      </div>
    </section>
  );
};

export default PressSection;
